import { useEffect, useRef, useState } from "react";
import { forgotPassword } from "../API";
import { toast } from "react-toastify";
import AuthLayout from "../components/AuthLayout";

const ForgetPassword = () => {
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const focus = useRef();

  useEffect(() => {
    focus.current.focus();
  }, []);

  const onSubmitReset = async () => {
    if (email === "") {
      toast.warning("Email field is empty");
    } else {
      setIsLoading(true);
      const payload = {
        email,
      };
      await forgotPassword(payload).then((res) => {
        setIsLoading(false);

        if (res?.status === 200) {
          toast.success("Password reset comfirmation sent on your email");
          setEmail("");
        }
      });
    }
  };

  const onEmailChange = (e) => {
    setEmail(e?.target?.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmitReset();
  };

  return (
    <AuthLayout>
      <h2 className="auth-title">Forgot password</h2>
      <p className="auth-subtitle">
        Enter your account email and we&apos;ll send you a reset link.
      </p>
      <form noValidate onSubmit={handleSubmit}>
        <label className="visually-hidden" htmlFor="forgot-email">
          Email address
        </label>
        <input
          ref={focus}
          onChange={(e) => onEmailChange(e)}
          type="email"
          name="email"
          id="forgot-email"
          className="auth-input"
          placeholder="E-mail address"
          autoComplete="email"
          value={email}
        />
        <div className="auth-actions">
          <button type="submit" className="auth-submit" disabled={isLoading}>
            {isLoading && (
              <span
                className="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
              ></span>
            )}
            Send reset link
          </button>
          <a href="/" className="auth-forgot">
            Back to log in
          </a>
        </div>
      </form>
    </AuthLayout>
  );
};

export default ForgetPassword;
